export default function SmallButton({ caption, icon, url, bgClass, textClass }) {
    const className = "d-inline-flex justify-content-center align-items-center h-20 w-30 text-decoration-none mr-5 border-transparent rounded " + bgClass + " " + textClass;
    return (
        <a href={url} target="_blank" className={className}>
            {icon}
            {caption}
        </a>
    )
}